<template>
  <!-- Modal terms -->
  <div
    class="modal fade"
    id="mobile-verified-modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="mobileVerifiedModal"
    aria-hidden="false"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="mobileVerifiedModal">
            <span class="alert-icon">
              <i class="fa fa-thumbs-o-up"></i>
            </span>
            {{ $t('Cep Telefonunuz Onaylandı') }}
          </h4>
          <button id="mobileVerifiedModalClose" type="button" class="close" data-dismiss="modal" aria-hidden="true">
            &times;
          </button>
        </div>
        <div class="modal-body modal-body-min">
          <p>{{ $t('Cep Telefonunuz Onaylandı text') }}</p>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- /.modal -->
</template>
<script>
export default {
  name: 'mobileVerifiedModal',
  data() {
    return {};
  },
  methods: {},
};
</script>
